import { render, staticRenderFns } from "./CajerosForm.vue?vue&type=template&id=1b8a1376&scoped=true"
import script from "./CajerosForm.vue?vue&type=script&lang=js"
export * from "./CajerosForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8a1376",
  null
  
)

export default component.exports